import { useEffect } from "react";
export var usePageTitle = function usePageTitle(title) {
  useEffect(function () {
    setTimeout(function () {
      document.title = "".concat(title, " | Crusher");
    }, 10);
  }, [title]);
};
export var useBasicSEO = function useBasicSEO(_ref) {
  var favicon = _ref.favicon;
  useEffect(function () {
    var link = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement("link"); // @ts-ignore

      link["rel"] = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    } // @ts-ignore


    link.href = favicon;
  }, [favicon]);
};